import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'keyValueSort',
})
export class KeyValueSortPipe implements PipeTransform {
    transform(value: Record<string, any>): { key: string; value: any }[] {
        if (!value) return [];
        return Object.entries(value)
            .map(([key, val]) => ({ key, value: val }))
            .sort((a, b) => (Number(a.key) > Number(b.key) ? 1 : -1));
    }
}
